module.exports = __webpack_public_path__ + "assets/img/94b8b1a67336b4016ff1d0d69f58c564.svg";